import device from 'current-device';
import { DevicePlatform, DeviceType } from '../constants/deviceEnums';
import { isWindowExists } from './windowHelper';
import get from 'lodash.get';

export class DeviceHelper {
    static getDeviceType = () => {
        if (isWindowExists()) {
            const type = get(device, 'type');
            const deviceType = DeviceType[type];

            return deviceType ? deviceType : DeviceType.other;
        }
        return DeviceType.other;
    }

    static getDevicePlatform = () => {
        if (isWindowExists()) {
            if (DeviceHelper.isMac()) {
                return DevicePlatform.macos;
            }

            const platform = get(device, 'os');
            const devicePlatform = DevicePlatform[platform];

            return devicePlatform ? devicePlatform : DevicePlatform.other;
        }
        return DevicePlatform.other;
    }

    static isMac = () => {
        return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    }
} 
